import * as SheetPrimitive from '@radix-ui/react-dialog';
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { cn } from '@/lib/utils';

export const Sheet = SheetPrimitive.Root;

/** Bottom sheet: painel colado na parte de baixo da tela, centrado, cantos superiores arredondados. */
export const SheetContent = forwardRef<
  ElementRef<typeof SheetPrimitive.Content>,
  ComponentPropsWithoutRef<typeof SheetPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <SheetPrimitive.Portal>
    <SheetPrimitive.Overlay className="fixed inset-0 z-[100] animate-overlay-in bg-[rgba(20,18,15,0.45)]" />
    <SheetPrimitive.Content
      ref={ref}
      aria-describedby={undefined}
      className={cn(
        'fixed inset-x-0 bottom-0 z-[101] mx-auto max-h-[90dvh] w-full max-w-[480px] animate-sheet-up overflow-y-auto rounded-t-2xl bg-surface px-[22px] pb-[calc(26px_+_env(safe-area-inset-bottom))] pt-6 outline-none',
        className,
      )}
      {...props}
    >
      {children}
    </SheetPrimitive.Content>
  </SheetPrimitive.Portal>
));
SheetContent.displayName = 'SheetContent';

export const SheetTitle = forwardRef<
  ElementRef<typeof SheetPrimitive.Title>,
  ComponentPropsWithoutRef<typeof SheetPrimitive.Title>
>(({ className, ...props }, ref) => (
  <SheetPrimitive.Title
    ref={ref}
    className={cn('mb-[18px] text-[17px] font-bold text-fg', className)}
    {...props}
  />
));
SheetTitle.displayName = 'SheetTitle';
